import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;

export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    api.get("/site-settings").then((r) => { _cache = r.data; setSettings(r.data); }).catch(() => {});
  }, []);
  return settings;
}
